import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import DetailService from '@/core/services/detail.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class ProfileDetailComponent extends Vue {

  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  profileList: any = [];
  profile_id: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  name: string = "";
  companyName: string = "";
  createdAt: string = "";
  updatedAt: string = "";
  profileHierarchyOne: string = "";
  profileHierarchyTwo: string = "";
  profileHierarchyThree: string = "";
  profileHierarchyFour: string = "";
  profileHierarchyFive: string = "";
  profileHierarchySix: string = "";
  profileHierarchySeven: string = "";
  profileHierarchyEight: string = "";
  profileHierarchyNine: string = "";
  profileHierarchyTen: string = "";
  profileHierarchyEleven: string = "";
  profileHierarchyTwelve: string = "";

  mounted (){
    const _ = this;
    _.getByCompany();
    _.getByProfile();
    _.filterDate();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getByCompany(){
    const _ = this;
    let company_id: any = location.href.split("/");
    company_id = company_id[5];
    _.isLoading = true;
    _.detailService.getByCompany(company_id).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.companyName = data["data"].company.name;
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getByProfile(){
    const _ = this;
    _.profile_id = location.href.split("/");
    _.profile_id = _.profile_id[5];
    _.isLoading = true;
    _.detailService.getByProfile(_.profile_id).then((data: any) => {
      console.log(data);
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      console.log(data["data"], 'data')
      _.name = data["data"].profile.name;
      _.profileHierarchyOne = data["data"].profile.profile_skills[0].expectedPercentage;
      _.profileHierarchyTwo = data["data"].profile.profile_skills[1].expectedPercentage;
      _.profileHierarchyThree = data["data"].profile.profile_skills[2].expectedPercentage;
      _.profileHierarchyEight = data["data"].profile.profile_skills[3].expectedPercentage;
      _.profileHierarchyNine = data["data"].profile.profile_skills[4].expectedPercentage;
      _.profileHierarchyFour = data["data"].profile.profile_skills[5].expectedPercentage;
      _.profileHierarchySeven = data["data"].profile.profile_skills[6].expectedPercentage;
      _.profileHierarchyTen = data["data"].profile.profile_skills[7].expectedPercentage;
      _.profileHierarchySix = data["data"].profile.profile_skills[8].expectedPercentage;
      _.profileHierarchyEleven = data["data"].profile.profile_skills[9].expectedPercentage;
      _.profileHierarchyFive = data["data"].profile.profile_skills[10].expectedPercentage;
      _.profileHierarchyTwelve = data["data"].profile.profile_skills[11].expectedPercentage;
      _.createdAt = data["data"].profile.createdAt;
      _.updatedAt = data["data"].profile.updatedAt;
      console.log(_.createdAt, 'jsjsjs');

    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }
}
